import { useDedupEffect } from "@npd-ng/adp-component-library";
import { IADPState,HeartBeat } from "../typings";
import { HEADER_HB } from "../util/constants";
import { useFetchService } from "./useFetchService";
import { useSelector } from "react-redux";
 
let intervalId: any = undefined;
export function useHeartbeatService(props:{heartBeatUrl:string}) {

    const state = useSelector(
        (state: { rootState: IADPState }) => state.rootState
      );
    let numberOfHeartbeatPending = 0;
    const {fetch} =useFetchService()
    const post = async (cb?: any) => {
        if (!state.sessionState.schoolDetails?.setupCode) {
            cancelHeartbeat();
            return;
        } 
        const payload: HeartBeat = {
            clientLaunchId: state.appState.appLaunchId as string,
            setupCode: state.sessionState.schoolDetails?.setupCode?.toUpperCase() as string,
            deviceId: state.deviceState.deviceId as string,
            loginId: "NA"
        }
        const url = props.heartBeatUrl
        const response = await fetch(url,{method: "POST",body:JSON.stringify(payload),headers:HEADER_HB});
        cb(response);  
        }
    const initHeartbeat = (interval?: number) => {
        numberOfHeartbeatPending++;
        const callback = () => {
            numberOfHeartbeatPending--;
        }
        post(callback);
        if (typeof intervalId === 'number') {
            console.log(`[Heartbeat Service][Clearing interval] ${intervalId}`);
            clearInterval(intervalId);
        }
        intervalId = setInterval(() => {
            if (numberOfHeartbeatPending > 0) return;
            const callback = () => {
                numberOfHeartbeatPending--;
            }
            numberOfHeartbeatPending++;
            post(callback);
        }, interval ? interval : (state.appState.configuration?.heartbeatIntervalSec || 10) * 1000)
    }
    const cancelHeartbeat = () => {
        if (typeof intervalId === 'number') {
            console.log(`[Heartbeat Service][Canceling Heartbeat] ${intervalId}`);
            clearInterval(intervalId);
        }
    }
    useDedupEffect(() => {
        cancelHeartbeat();
        //console.log(state.sessionState.schoolDetails?.setupCode)
        if(state.sessionState.schoolDetails?.setupCode){
            console.info(`[Heartbeat Service][Init Heartbeat] ${intervalId}`);
            initHeartbeat();
        }
    },[state.sessionState.schoolDetails?.setupCode])
    return { post, cancelHeartbeat, initHeartbeat }
}
